import { FC, memo } from 'react'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  size?: number | number[]
}

const CitizenProfileModuleBrand: FC<Props> = ({ size = 12 }) => {
  const [primary200, primary300, primary400, primary500, primary600, primary700, primary900, white] = useToken(
    'colors',
    ['primary.200', 'primary.300', 'primary.400', 'primary.500', 'primary.600', 'primary.700', 'primary.900', 'white']
  )

  const strokeColor900 = useColorModeValue(primary900, primary900)
  const strokenWidth = '40px'
  const fillColor200 = useColorModeValue(primary200, primary300)
  const fillColor400 = useColorModeValue(primary400, primary500)
  const fillColor600 = useColorModeValue(primary600, primary700)
  const fillBG = useColorModeValue(white, white)

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
        <g id="Perfil_Cidadão" data-name="Perfil Cidadão">
          <g>
            <g id="group200">
              <path
                fill={fillColor200}
                opacity="0.25"
                d="M130.59,626.05S-1,490,33,275,208.93,56.7,236,59c47,4,89.18,73,120,238,9.44,50.56,118.22,105,232.11,47s159-42.5,168.89-27c33,52,1.67,151.56-74.67,244.78S492,741,378,735,164,661,130.59,626.05Z"
              />
            </g>
            <g id="group400">
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M680.74,453.57a70.62,70.62,0,0,1-12.2,33.69c-22.35,33-63.54,98-100.56,105.8-59.8,12.54-53.28-81.25-70.13-125.92C451.49,344.17,688.67,356,680.74,453.57Z"
              />
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M369.7,70.48a58.11,58.11,0,0,1,29.54.26C431,79.08,492.91,93.29,509.09,120,535.23,163,460.5,183.66,430.37,209,347.44,278.75,291.62,91.05,369.7,70.48Z"
              />
            </g>
            <g id="group600">
              <path
                fill={fillColor600}
                d="M63.48,493.27a64.13,64.13,0,0,1,5.59-40.16c27.54-55.93,133.6-252.85,284.37-303.78C538,87,595,119,617.44,134.22c18.19,12.34,97.23,87.67,96.89,182.22S674,518,630.78,581.33c-21.71,31.81-34.1,39-54.94,31.85S409.9,548.71,336,568c-110,28.72-183.78,24.49-255.44-40.89C70.4,517.84,65.64,504.77,63.48,493.27Z"
              />
              <path
                fill={fillColor600}
                d="M725.85,150.15c-21.7-3.54-56.69-5.79-69.27-26.51-13.72-22.57-2-47.18,25.09-51.58C732.63,63.81,741.27,151.34,725.85,150.15Z"
              />
              <path
                fill={fillColor600}
                d="M69,587.62c1.88-5.69,10-5.82,11.81-.13,8,24.58,26.69,42.54,44.51,61.16,20.09,21,36.28,32.11-1.51,37.85C65.26,695.41,59.35,616.89,69,587.62Z"
              />
              <path
                fill={fillColor600}
                d="M706.15,575a10,10,0,0,1-15,2.7,10.19,10.19,0,0,1-2.16-13c2.78-4.82,6.86-13.67,11.57-10.93S708.92,570.2,706.15,575Z"
              />
            </g>
          </g>
          <g id="icon">
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill={fillBG}
              d="M449.18,202.6h99.47a49.74,49.74,0,0,1,49.74,49.74V575.63a49.74,49.74,0,0,1-49.74,49.73H250.24a49.74,49.74,0,0,1-49.74-49.74V252.34a49.74,49.74,0,0,1,49.74-49.74h99.47"
            />
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill={'none'}
              d="M439,343.33a56,56,0,1,1-79.13,0,56,56,0,0,1,79.13,0"
            />
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill={'none'}
              d="M488.85,550.76a78.89,78.89,0,0,0-19.7-28.7h0a78.9,78.9,0,0,0-53.64-21H383.38a78.9,78.9,0,0,0-53.64,21h0a78.89,78.89,0,0,0-19.7,28.7"
            />
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill={fillBG}
              d="M424.31,252.34H374.58a24.86,24.86,0,0,1-24.87-24.87v-74.6A24.86,24.86,0,0,1,374.58,128h49.73a24.86,24.86,0,0,1,24.87,24.87v74.6A24.86,24.86,0,0,1,424.31,252.34Z"
            />
          </g>
        </g>
      </svg>
    </Box>
  )
}

export default memo(CitizenProfileModuleBrand)
